module.exports = __webpack_public_path__ + "img/1497673318.6b2c0629.jpg";